import type { components } from "../generated/openapi-types";

type FileNaming = components["schemas"]["FileNaming"];

// The file name, annotated. A name from the bank is not a label — it is
// structured: a letter saying what kind of file this is, the delivery number,
// and the delivery type. So it is set out the way a record is, with each part
// named underneath, rather than printed as one opaque string.

export function FileNameKey({ name, naming }: { name: string; naming?: FileNaming }): JSX.Element {
  const parts = naming?.parts ?? [];
  if (parts.length === 0) return <h2>{name}</h2>;

  return (
    <h2 className="name-key">
      {parts.map((part, index) => (
        <span className="name-part" key={`${part.text}-${index}`} title={part.detail ?? part.label}>
          <span className="part-text">{part.text}</span>
          <span className="part-label">{part.label}</span>
        </span>
      ))}
    </h2>
  );
}

/** The prefix key, for the rail. Five letters cover every file the bank sends. */
export function FileNameLegend(): JSX.Element {
  return (
    <details className="legend">
      <summary>What the file names mean</summary>
      <dl>
        <dt>D</dt>
        <dd>Data file — the delivery itself. This is what becomes an event.</dd>
        <dt>F</dt>
        <dd>Cover sheet (følgeseddel) — the same data as readable text. Not processed.</dd>
        <dt>V</dt>
        <dd>Validation receipt — whether a delivery we sent was accepted.</dd>
        <dt>T</dt>
        <dd>Transmission receipt — whether it arrived on the server at all.</dd>
        <dt>Z</dt>
        <dd>Data file, zipped. Only for mailboxes set up for zipped format.</dd>
      </dl>
      <p>
        The digits after the letter are the bank's delivery number, and <code>-602</code> style suffixes are
        the delivery type.
      </p>
    </details>
  );
}
